import { Drawer } from "antd";
import { createGlobalStyle } from "styled-components";
import { PortalHeader } from "../../../components/molecules/Header";
import { portalDrawerAntHeaderCss } from "../../../components/molecules/Header/Header.styles";

export const orderDrawerPanelStyles = {
  header: { padding: 0 },
  body: { padding: 0, overflow: "auto" },
  footer: { padding: 0 },
  mask: { backgroundColor: "rgba(0, 0, 0, 0.3)", backdropFilter: "blur(1px)" },
};

const DrawerHeaderTheme = createGlobalStyle`
  ${({ $rootClassName }) =>
    $rootClassName
      ? `
  .${$rootClassName} .ant-drawer-header {
    ${portalDrawerAntHeaderCss}
  }
`
      : ""}
`;

/**
 * Standard antd drawer chrome for order CRUD pages (PortalHeader + panel styles).
 */
export const OrderDrawerShell = ({
  open = true,
  onClose,
  title,
  width,
  footer,
  children,
  rootClassName,
  placement = "right",
  closable = false,
  maskClosable = true,
  keyboard = true,
  destroyOnClose = true,
  afterOpenChange,
  styles = orderDrawerPanelStyles,
  extraTheme,
  ...drawerProps
}) => {
  const headerTitle =
    typeof title === "string" ? <PortalHeader title={title} onClose={onClose} /> : title;

  return (
    <>
      {rootClassName ? <DrawerHeaderTheme $rootClassName={rootClassName} key={rootClassName} /> : null}
      {extraTheme}
      <Drawer
        open={open}
        title={headerTitle}
        rootClassName={rootClassName}
        placement={placement}
        width={width}
        styles={styles}
        onClose={onClose}
        closable={closable}
        maskClosable={maskClosable}
        keyboard={keyboard}
        destroyOnClose={destroyOnClose}
        afterOpenChange={afterOpenChange}
        footer={footer}
        {...drawerProps}
      >
        {children}
      </Drawer>
    </>
  );
};
